import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { FRANCHISE_LABELS } from './';
export default defineComponent({
    name: 'FranchiseLabel',
    props: {
        profitable: {
            default: 0,
            type: Number,
        },
        shouldShortTitle: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        const css = useCssModule();
        const currentLabel = computed(() => {
            const label = FRANCHISE_LABELS[props.profitable];
            if (!label) {
                return null;
            }
            const { theme } = label;
            let { title } = label;
            if (!props.shouldShortTitle) {
                title += ' Forbes';
            }
            return {
                theme,
                title,
            };
        });
        return {
            css,
            currentLabel,
        };
    },
});
